import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ArrowsChevronDownRegularIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 16c-.234 0-.453-.1-.618-.282L5.128 8.825C5.046 8.735 5 8.612 5 8.483c0-.128.045-.25.128-.34.082-.092.193-.143.31-.143.116 0 .227.051.309.143l6.252 6.892 6.253-6.892c.082-.092.193-.143.31-.143.116 0 .227.051.309.143.082.09.129.212.129.34 0 .129-.047.251-.13.341l-6.252 6.894c-.164.181-.386.283-.619.282z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ArrowsChevronDownRegularIcon = __decorateClass([
  customElement("elm-arrows-chevron-down-regular-icon")
], ArrowsChevronDownRegularIcon);
export { ArrowsChevronDownRegularIcon };
